module.exports = __webpack_public_path__ + "static/media/land-placeholder.6426cb09.png";